module.exports = __webpack_public_path__ + "static/media/buzhou4.5f7d7c5b.png";